export default "__VITE_ASSET__B$VIniyB__"